module.exports = __webpack_public_path__ + "static/ic_home_more.ee1ac7bd.svg";